import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { IUseMapExtended, IUseMapExtendedParam } from './types';
import useAppleMap from './use-apple-map.web';
import useGoogleMap from './use-google-map.web';

/**
 * This hook provides extended map functionality (focusToPoints, getCurrentCenter, renderMarkers) supporting both:
 * - Apple MapKit JS (when ENABLE_APPLE_MAPKIT_WEB flag is enabled)
 * - Google Maps JS (when flag is disabled)
 */
export const useMap: IUseMapExtended = (props: IUseMapExtendedParam) => {
  const enabledAppleMapkit = useFlag(LaunchDarklyFlag.ENABLE_APPLE_MAPKIT_WEB);

  const appleResult = useAppleMap(props, enabledAppleMapkit);
  const googleResult = useGoogleMap(props, !enabledAppleMapkit);

  return enabledAppleMapkit ? appleResult : googleResult;
};
